import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import moment from 'moment';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  {/*const [user, setUser] = useState(null);*/}
  const history = useHistory();
  const responseData = JSON.parse(localStorage.getItem("responseData"));

  /*const lastLogin = moment(user.lastLogin);
  const now = moment();
  const isFirstLoginToday = !lastLogin.isSame(now, 'day');

  if (isFirstLoginToday) {
    sessionStorage.setItem('shouldHitThirdPartyAPI', 'true');
    console.log(sessionStorage.setItem('shouldHitThirdPartyAPI', 'true'));
  }

  const shouldHitThirdPartyAPI = sessionStorage.getItem('shouldHitThirdPartyAPI') === 'true';

  if (shouldHitThirdPartyAPI) {
    // Hit the 3rd party API here
    sessionStorage.removeItem('shouldHitThirdPartyAPI'); // Reset the flag value
    console.log(sessionStorage.removeItem('shouldHitThirdPartyAPI'));

  }*/
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
////code added by dev
///  // chk user in local server
   const stepa = await axios.get(`https://testwire.wockhardt.com/api/users?filters[email][$eq]=${email}&pagination[limit]=1/`);
   console.log(stepa);
  if(!stepa.data || stepa.data.length === 0){
    // chk for user by email id remote server
     const stepb = await axios.get(`https://e2api.wockhardt.com/api/Flutter/GetEmpDetailsEmail?email=${email}`);

     if(!stepb.data || stepb.data.length === 0){
       setMessage("Your Email not exist in system . Please chk Email.");
       return;
     }
     else{
      // new user create on 
      //const res = await axios.get(`https://e2api.wockhardt.com/api/Flutter/GetEmpDetailsEmail?email=${email}`);
   //console.log(res);

  //let username = stepb.data[0].empname; // Assuming 'empname' is the username
  let username = email;
 let emailx = email;
let  npassword=password;
let job = stepb.data[0].jobrole;
let education = stepb.data[0].education; // Assuming 'education' is available in the response
let previousemployment = stepb.data[0].previousemployment; // Assuming 'previousemployment' is available in the response
let address = stepb.data[0].address;
let pan = stepb.data[0].pan;
let aadhar = stepb.data[0].aadharNo;
let uan = stepb.data[0].uan; // Assuming 'password' is available in the response
let contactno = stepb.data[0].personalMobile;
let designation = stepb.data[0].position;
let empcode = stepb.data[0].empcode;
let Gender = stepb.data[0].gender;
let dob = chdte(stepb.data[0].dob);
let picture = stepb.data[0].picture; // Assuming 'picture' is available in the response
let pictureurl = stepb.data[0].pictureurl; // Assuming 'pictureurl' is available in the response
let positioN_CODE = stepb.data[0].positioN_CODE;
let area = stepb.data[0].area;
let subarea = stepb.data[0].subarea;
let subgroup = stepb.data[0].subgroup;
let doj = chdte(stepb.data[0].doj);
let companY_CODE = stepb.data[0].companY_CODE;
let cosT_CENTER = stepb.data[0].cosT_CENTER;
let worK_CNTRCT = stepb.data[0].worK_CNTRCT;
let organization = stepb.data[0].organization;
let communication = stepb.data[0].communication;
let flM_CODE = stepb.data[0].flM_CODE;
let reP_MGR = stepb.data[0].reP_MGR;
let peR_ADMIN = stepb.data[0].peR_ADMIN;
let paY_ADMIN = stepb.data[0].paY_ADMIN;
let orG_CODE = stepb.data[0].orG_CODE;
let country = stepb.data[0].country;
let profileapproved = stepb.data[0].profileapproved;
let salutation = stepb.data[0].salutation;
let lastName = stepb.data[0].lastName;
let firstName = stepb.data[0].firstName;
let middleName = stepb.data[0].middleName;
let officialEmail = stepb.data[0].officialEMail;
let personalMobile = stepb.data[0].personalMobile;
let bankName = stepb.data[0].bankName;
let bankAccountNo = stepb.data[0].bankAccountNo;
let ifsc = stepb.data[0].ifsc;
let aadharName = stepb.data[0].aadharName;
let pfNo = stepb.data[0].pfNo;
let passportNo = stepb.data[0].passportNo;
let personalEmail = stepb.data[0].personalEmail;
let officeTelNo = stepb.data[0].officeTelNo;
let officeMobile = stepb.data[0].officeMobile;
let peR_ADMIN_EMAIL = stepb.data[0].peR_ADMIN_EMAIL;
let peR_ADMIN_CODE = stepb.data[0].peR_ADMIN_CODE;
let funC_HEAD_CODE = stepb.data[0].funC_HEAD_CODE;
let funC_HEAD_EMAIL = stepb.data[0].funC_HEAD_EMAIL;
let updatedData = {
  username: username,
  email: emailx,
  password: npassword,
  job: job,
  role:2,
  education: education,
  previousemployment: previousemployment,
  address: address,
  pan: pan,
  aadhar: aadhar,
  uan: uan,
  contactno: contactno,
  designation: designation,
  empcode: empcode,
  Gender: Gender,
  dob: dob,
  picture: picture,
  pictureurl: pictureurl,
  positioN_CODE: positioN_CODE,
  area: area,
  subarea: subarea,
  subgroup: subgroup,
  doj: doj,
  companY_CODE: companY_CODE,
  cosT_CENTER: cosT_CENTER,
  worK_CNTRCT: worK_CNTRCT,
  organization: organization,
  communication: communication,
  flM_CODE: flM_CODE,
  reP_MGR: reP_MGR,
  peR_ADMIN: peR_ADMIN,
  paY_ADMIN: paY_ADMIN,
  orG_CODE: orG_CODE,
  country: country,
  profileapproved: profileapproved,
  salutation: salutation,
  lastName: lastName,
  firstName: firstName,
  middleName: middleName,
  officialEmail: officialEmail,
  personalMobile: personalMobile,
  bankName: bankName,
  bankAccountNo: bankAccountNo,
  ifsc: ifsc,
  aadharName: aadharName,
  pfNo: pfNo,
  passportNo: passportNo,
  personalEmail: personalEmail,
  officeTelNo: officeTelNo,
  officeMobile: officeMobile,
  peR_ADMIN_EMAIL: peR_ADMIN_EMAIL,
  peR_ADMIN_CODE: peR_ADMIN_CODE,
  funC_HEAD_CODE: funC_HEAD_CODE,
  funC_HEAD_EMAIL: funC_HEAD_EMAIL
};
console.log(updatedData);

  const stepfour = await axios.post('https://testwire.wockhardt.com/api/users', updatedData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });


     }
//return;

  }
//////end code by dev


      const response = await axios.post(
	      'https://testwire.wockhardt.com/api/auth/local/',
        {
          identifier: email,
          password: password,
        }
      );
      localStorage.setItem("responseData", JSON.stringify(response.data));
      localStorage.setItem('jwt', response.data.jwt); 
      window.location = '/';
      setMessage("You are successfully Login.");
      localStorage.setItem("isUserLoggedIn", true);
      console.log(response.data);
      //alert('Success');
      //console.log('Well done!');
      //console.log('User profile', response.data.user);
      //console.log('User profile', response.data.user.username);
      //console.log('User token', response.data.jwt);
     
    } catch (error) {
      console.error(error);
      //alert("Error While Getting Logged In User Details");
      setMessage(error.response.data.error.message);
      //setMessage("An error occurred. Please try again later.");
      
    }
  };

  return (
    <div className='bg-silver1'>
      <section>     
        <div className="bg-silver1">
        <div className='lg:flex justify-around pt-8 mx-4'>
      <div className='bg-white rounded-2xl p-4 my-4 lg:my-0 ' style={{ background:'#fff', position:"relative", paddingTop:30, paddingBottom:30, paddingLeft:60, paddingRight:60, fontSize:16, fontWeight:400 }}>
    <div className='lg:flex'>
      <div className='lg:w-[50%]'>
        {/*<img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img>*/}
        <img src="/Other_Images/coverPic.png" class="img-fluid" alt=""></img>
      </div>
      <div className='lg:w-[50%]' style={{ marginTop: 'auto', marginBottom: 'auto' }}>
        <img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" style={{marginBottom:10}} alt=""></img>
        <h3 style={{fontWeight:'700', fontSize:'1.625rem', marginBottom:'0.25rem !important'}}>Welcome to E2-Portal! 👋</h3>
        <p className="mb-4" style={{marginBottom:'0.25rem !important;'}}>Please sign-in to your account and start exploring</p>
         {message && <p class="error-message error" style={{ color:'white', backgroundColor:'lightcoral', padding:'10px'}}><b>{message}</b></p>}
        <form className="mt-4" onSubmit={handleSubmit}>
          <div className="form-group text-xs" style={{ marginTop:'5%', fontWeight:400 }}>
            <label for="exampleInputEmail1" style={{ display:"inline-block", marginBottom:8,fontSize: '0.8125rem',color: '#5d596c' }}>Email Id</label>
          </div>
          <input className="text-xs" style={{ width:'100%', lineHeight:'1.5', background:'#ffffff',border: '1px solid #dbdade',borderRadius: '0.375rem', padding: '0.422rem 0.875rem',fontSize:'0.9375rem', marginBottom:0, fontWeight:400, }} type="email" placeholder="Enter your Registered Email Id" value={email} onChange={(event) => setEmail(event.target.value)}/>
          <div className="form-group text-xs" style={{ marginTop:'5%', fontWeight:400 }}>
            <label for="exampleInputPassword1" style={{ display:"inline-block", marginBottom:8, fontSize: '0.8125rem',color: '#5d596c' }}>Password</label>
          </div>
          <input className="text-xs" style={{ width:'100%', lineHeight:'1.5', background:'#ffffff',border: '1px solid #dbdade',borderRadius: '0.375rem', padding: '0.422rem 0.875rem', fontSize:'0.9375rem', marginBottom:0, fontWeight:400}} type="password" placeholder="Enter your Password" value={password} onChange={(event) => setPassword(event.target.value)}/>
          <div class="d-inline-block w-100 text-sm">
            <button className="text-xs" style={{ marginTop:'5%', padding:10, color:'#fd6047', width:'100%', color:'#fff', backgroundColor:'#2f75b6', borderColor:'#2f75b6' }} type="submit" class="btn btn-primary">Sign in</button>
            {/*<span style={{ color:'#ccc' }}>|</span>*/}
            {/*<a className="text-xs" href="/resetpassword" style={{ marginTop:10, padding:10 }} type="submit" class="btn btn-primary center">Forgot Password?</a>*/}
          </div> 
          
          <p class="text-center" style={{ marginTop:10, padding:10, color:'#2f75b6' }}><a type="submit" class="btn btn-primary center" href="/resetpassword"><span>Forgot Password?</span></a></p>                
        </form>
        
      </div>
    </div>
  </div>
</div>

        </div>
      </section> 
    </div>
  );
};
function chdte(dobString) {

let dobParts = dobString.split('.');  // Split into day, month, year
let dobObject = new Date(dobParts[2], dobParts[1] - 1, dobParts[0]); // Create a Date object
let formattedDob = dobObject.toISOString().slice(0, 10);
return formattedDob;
}
export default Login;
